import { useSimpleKitContext } from "@/react/context/SimpleKitContext";
import { useSignAccount } from "@/react/hooks";
import { Spinner } from "@/react/icons";
import { Button } from "@/react/shadcn/ui/button";
import { cn } from "@/react/shadcn/utils";
import { RotateCcw } from "lucide-react";
import { useEffect } from "react";

export function AccountSigning() {
  const { pendingItem } = useSimpleKitContext();

  const {
    error,
    isError,
    isPending,
    mutateAsync: signAccount,
  } = useSignAccount();

  useEffect(() => {
    signAccount();
  }, [pendingItem]);

  if (!pendingItem) {
    return null;
  }

  return (
    <div className="web3kit-flex web3kit-w-full web3kit-flex-col web3kit-items-center web3kit-justify-center web3kit-gap-9 md:web3kit-pt-5">
      <div
        className={cn(
          "web3kit-relative web3kit-size-28 web3kit-flex web3kit-items-center web3kit-justify-center web3kit-rounded-2xl web3kit-p-3"
        )}
      >
        <img
          src={pendingItem.logo}
          alt={pendingItem.name}
          className="web3kit-size-16 web3kit-overflow-hidden web3kit-rounded-2xl"
        />

        {!isPending && isError ? (
          <Button
            size="icon"
            variant="ghost"
            className="web3kit-group web3kit-absolute -web3kit-bottom-2 -web3kit-right-2 web3kit-rounded-full web3kit-bg-muted web3kit-p-1.5 web3kit-shadow"
            onClick={() => {
              signAccount();
            }}
          >
            <RotateCcw className="web3kit-size-4 web3kit-transition-transform group-hover:-web3kit-rotate-45" />
          </Button>
        ) : (
          <Spinner className="web3kit-absolute web3kit-w-full web3kit-h-full web3kit-text-primary web3kit-animate-spin" />
        )}
      </div>

      <div className="web3kit-space-y-3.5 web3kit-px-3.5 web3kit-text-center sm:web3kit-px-0">
        <h1 className="web3kit-text-xl web3kit-font-semibold">
          {isError || error ? "Request Error" : "Requesting Connection"}
        </h1>
        <p className="web3kit-text-balance web3kit-text-sm web3kit-text-muted-foreground">
          {isError || error
            ? "There was an error with the request. Click above to try again."
            : `We're verifying your ${pendingItem.id} account.`}
        </p>
      </div>
    </div>
  );
}
